export default "__VITE_ASSET__BXGZe1W7__"